import React from 'react'
import { mixpanel, snowplow } from 'common/helpers/analytics'


type NavItem = {
  to?: string
  toOLD?: string
  toTab?: string
  href?: string
  onClick?: React.MouseEventHandler
  title?: ReactIntlMessage | string
  userLoggedIn?: 'yes' | 'no'
  redirect?: string
  analyticTitle?: string
}

type Events = {
  mixpanelEvent?: string
  snowplowEvent?: string
}

type Params = {
  link: string
  title: string
  userLoggedIn?: string
}

const getTrackingEventToNavItem = <T extends NavItem>(navItem: T, events: Events): T => {
  const { to, toOLD, toTab, href, onClick, title, userLoggedIn, analyticTitle, ...rest } = navItem
  const { mixpanelEvent, snowplowEvent } = events

  return {
    title,
    to,
    toOLD,
    toTab,
    href,
    ...rest,
    onClick: (event) => {
      const params: Params = {
        link: to || toOLD || toTab || href || navItem.redirect,
        title: analyticTitle || (typeof title === 'object' ? title.en : title),
      }

      if (userLoggedIn !== undefined) {
        params.userLoggedIn = userLoggedIn
      }

      if (snowplowEvent) {
        snowplow.track(snowplowEvent, params)
      }

      if (mixpanelEvent) {
        mixpanel.track(mixpanelEvent, params)
      }

      if (typeof onClick === 'function') {
        onClick(event)
      }
    },
  } as T
}


export default getTrackingEventToNavItem
